import React from "react";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import {
  Compass,
  Anchor,
  Shield,
  Award,
  Users,
  ChevronRight,
  Wind,
  CheckCircle2,
} from "lucide-react";
import { Zap, Heart, Sparkles, MapPin, Waves } from "lucide-react";
import Footer from "../Components/Footer";
import FAQSection from "../Components/FAQSection";

const regattaFaqs = [
  {
    question: "What is a corporate sailing regatta in Mumbai?",
    answer:
      "A corporate sailing regatta in Mumbai is a team-building sailing experience where employees or business groups take part in a structured on-water format designed to build teamwork, communication and leadership."
  },
  {
    question: "How is a corporate sailing regatta different from a regular team outing?",
    answer:
      "A regular team outing is usually passive and social, while a sailing regatta is interactive and participation-led, which makes it more effective for team building and engagement."
  },
  {
    question: "Why is a sailing regatta good for team building?",
    answer:
      "It naturally encourages communication, collaboration, decision-making, trust and shared achievement, which are all important team qualities."
  },
  {
    question: "What happens during a corporate sailing regatta?",
    answer:
      "The experience may include briefing, team formation, guided sailing participation, regatta-style activity and shared team moments on the water."
  },
  {
    question: "Is this suitable for leadership teams?",
    answer:
      "Yes. Corporate sailing regattas work very well for leadership groups because they highlight strategy, calm decision-making and teamwork in a live environment."
  },
  {
    question: "What business goals can a corporate sailing regatta support?",
    answer:
      "It can support team building, employee engagement, leadership development, offsites, reward events and culture-building initiatives."
  },
  {
    question: "How is Indiaboats different for corporate regattas?",
    answer:
      "Indiaboats focuses on premium on-water corporate experiences and helps companies create sailing regattas that feel structured, meaningful and memorable."
  },
  {
    question: "How do I enquire about a corporate sailing regatta in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your preferred date, team size and event objective."
  }
];

const Regattas = () => {
  const highlights = [
    {
      text: "Premium corporate sailing regatta experiences in Mumbai",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <path d="M22 3c-1.1 0-2 1.2-2 2.5V17c0 .8-.4 1.5-1 2H5c-.6-.5-1-1.2-1-2V5.5C4 4.2 3.1 3 2 3" />
          <path d="M4 17a4 4 0 0 1 8 0v2" />
          <path d="M12 17a4 4 0 0 1 8 0v2" />
        </svg>
      )
    },
    {
      text: "Strong fit for team building and leadership development",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    },
    {
      text: "More engaging than routine corporate outings",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      )
    },
    {
      text: "Scenic and memorable on-water environment",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <path d="M2 10c3 0 3-3 6-3s3 3 6 3 3-3 6-3 3 3 6 3" />
          <path d="M2 17c3 0 3-3 6-3s3 3 6 3 3-3 6-3 3 3 6 3" />
        </svg>
      )
    },
    {
      text: "Better team participation and recall value",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      )
    },
    {
      text: "Experience-led planning and premium execution",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ibw-cntr-icon">
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      )
    }
  ];

   const benefitsList = [
    "Team building programs",
    "Leadership development experiences",
    "Employee engagement events",
    "Corporate offsites in Mumbai",
    "Sales team motivation",
    "Reward and recognition events",
    "HR-led culture-building activities",
    "Business groups wanting a premium shared experience"
  ];

  const outcomes = [
    {
      text: "Teamwork and collaboration",
      description:
        "Synchronize weight and pull lines in absolute unison to balance the boat against shifting winds.",
      icon: <Users size={20} />,
    },
    {
      text: "Leadership and decision-making",
      description:
        "Make split-second steering calls in unpredictable, high-stakes water currents.",
      icon: <Anchor size={20} />,
    },
    {
      text: "Communication under pressure",
      description:
        "Utilize clear, structured commands to cut through the roar of wind and crashing waves.",
      icon: <Zap size={20} />,
    },
    {
      text: "Trust and role clarity",
      description:
        "Rely completely on individual crew actions, knowing every position directly affects stability.",
      icon: <Shield size={20} />,
    },
    {
      text: "Strategy and coordination",
      description:
        "Map shifts in Mumbai harbor currents and out-maneuver competitor tracks.",
      icon: <Compass size={20} />,
    },
    {
      text: "Employee engagement",
      description:
        "Share adrenaline-fueled racing moments that forge unforgettable company memories.",
      icon: <Heart size={20} />,
    },
    {
      text: "Shared achievement",
      description:
        "Experience the deep satisfaction of crossing the finish line as one unified team.",
      icon: <Award size={20} />,
    },
    {
      text: "Positive team energy",
      description:
        "Breathe in the fresh sea air and return to the desk fully re-energized and inspired.",
      icon: <Sparkles size={20} />,
    },
    {
      text: "Stronger team connection outside the office",
      description:
        "Dissolve corporate hierarchy over post-race sea briefings and shared celebrations.",
      icon: <MapPin size={20} />,
    },
  ];

  return (
    <div>
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <section className="csrh-master-wrapper">
        {/* 
         Pro Tip: You can adjust the opacity level of the background image directly on 
         the ".csrh-absolute-bg" class below (currently set to 0.18) without affecting 
         the readability or opacity of the main title and text.
      */}
        <div className="csrh-absolute-bg"></div>
        <div className="csrh-absolute-overlay"></div>

        {/* Relative Content Area */}
        <div className="csrh-content-container">
          {/* Centered Editorial Header Section */}
          <div className="csrh-centered-header">
            <h1 className="csrh-hero-title">
              What Is a <br />
              <span className="csrh-title-italic">
                Corporate Sailing Regatta?
              </span>
            </h1>
           
          </div>

          {/* Narrative Copy Layout Grid */}
          <div className="csrh-narrative-grid">
            {/* Left Narrative Column */}
            <div className="csrh-narrative-column csrh-border-right">
              {/* Card block for Paragraph 1 */}
              <div className="csrh-text-card">
                <div className="csrh-card-icon-box">
                  <Users size={20} />
                </div>
                <div className="csrh-card-body">
                  <h3 className="csrh-card-subtitle">
                    Active Collaboration Format
                  </h3>
                  <p className="csrh-p-lead">
                    A corporate sailing regatta is a team-based sailing
                    experience where employees, leadership teams or business
                    groups take part in a structured activity on the water that
                    combines participation, teamwork and healthy competition.
                  </p>
                </div>
              </div>

              {/* Card block for Paragraph 2 */}
              <div className="csrh-text-card">
                <div className="csrh-card-icon-box">
                  <Wind size={20} />
                </div>
                <div className="csrh-card-body">
                  <h3 className="csrh-card-subtitle">
                    Live Decision-Making Environment
                  </h3>
                  <p className="csrh-p-body">
                    In simple terms, it is a corporate event built around
                    sailing. Instead of sitting through a routine offsite or
                    attending a passive team outing, participants work together
                    in a live environment where communication, coordination and
                    decision-making matter. The experience is designed to be
                    engaging, memorable and highly interactive.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Narrative Column */}
            <div className="csrh-narrative-column">
              {/* Card block for Paragraph 3 */}
              <div className="csrh-text-card csrh-premium-highlight">
                <div className="csrh-card-icon-box csrh-accent-icon">
                  <Anchor size={20} />
                </div>
                <div className="csrh-card-body">
                  <h3 className="csrh-card-subtitle csrh-accent-text">
                    Why It Matters in Mumbai
                  </h3>
                  <p className="csrh-p-body">
                    A corporate sailing regatta in Mumbai is especially valuable
                    because it gives teams something more than just a day out.
                    It creates a shared challenge and a shared experience.
                    People need to work together, stay aligned, adapt quickly
                    and support each other. That is what makes it such a strong
                    format for team building, leadership development and
                    employee engagement.
                  </p>
                </div>
              </div>

              {/* Card block for Paragraph 4 */}
              <div className="csrh-text-card">
                <div className="csrh-card-icon-box">
                  <Award size={20} />
                </div>
                <div className="csrh-card-body">
                  <h3 className="csrh-card-subtitle">
                    The Indiaboats Operational Guarantee
                  </h3>
                  <p className="csrh-p-body">
                    With Indiaboats, a corporate sailing regatta becomes a
                    premium on-water event that feels energetic, meaningful and
                    professionally managed from start to finish.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Footer Bar */}
          <div className="csrh-action-footer">
            <div className="csrh-trust-indicators">
              <div className="csrh-trust-pill">
                <Shield size={14} className="csrh-pill-icon" />
                <span>National Safety Protocols</span>
              </div>
              <div className="csrh-trust-pill">
                <Compass size={14} className="csrh-spin-slow csrh-pill-icon" />
                <span>Expert Skipper Command</span>
              </div>
            </div>

            <button className="csrh-premium-btn">
              <span>Enquire About Regattas</span>
              <div className="csrh-btn-arrow-wrap">
                <ChevronRight size={14} />
              </div>
            </button>
          </div>
        </div>
      </section>

      <section className="csrw-master-section">
        <div className="csrw-container">
          {}
          {/* Editorial Section Header */}
          <header className="csrw-header-block">
            <h2 className="csrw-section-title">
              How a Corporate{" "}
              <span className="csrw-serif-italic">Sailing Regatta Works</span>
            </h2>
            <p className="csrw-lead-narrative">
              A corporate sailing regatta is usually organised in a structured
              format so participants can enjoy the experience while also
              learning, engaging and competing as a team.
            </p>
          </header>

          {}
          {/* Chronological Process Grid */}
          <div className="csrw-process-flow">
            {/* Step 1 Card */}
            <div className="csrw-step-card">
              <div className="csrw-step-header">
                <div className="csrw-icon-box">
                  <Users size={22} />
                </div>
              </div>
              <div className="csrw-card-body">
                <h3 className="csrw-card-title">Welcome & Briefing</h3>
                <p className="csrw-card-text">
                  The day often begins with a welcome and briefing, where
                  participants are introduced to the event format and the
                  overall flow of the experience.
                </p>
              </div>
            </div>

            {/* Step 2 Card */}
            <div className="csrw-step-card">
              <div className="csrw-step-header">
                <div className="csrw-icon-box">
                  <Wind size={22} />
                </div>
              </div>
              <div className="csrw-card-body">
                <h3 className="csrw-card-title">Grouping & Guidance</h3>
                <p className="csrw-card-text">
                  Teams are then grouped and guided into the sailing activity.
                  Depending on the format, the event may include familiarisation
                  and active participation in a sailing-led team activity.
                </p>
              </div>
            </div>

            {/* Step 3 Card */}
            <div className="csrw-step-card">
              <div className="csrw-step-header">
                <div className="csrw-icon-box">
                  <Award size={22} />
                </div>
              </div>
              <div className="csrw-card-body">
                <h3 className="csrw-card-title">The Challenge</h3>
                <p className="csrw-card-text">
                  The experience culminates in a structured, regatta-style
                  challenge or competitive race element designed to test
                  alignment and coordination.
                </p>
              </div>
            </div>
          </div>

          {/* Value Takeaway Banner */}
          <div className="csrw-takeaway-banner">
            <div className="csrw-banner-inner">
              <div className="csrw-banner-icon-area">
                <CheckCircle2 size={32} className="csrw-check-icon" />
              </div>
              <div className="csrw-banner-content">
                <h4 className="csrw-banner-title">
                  What Makes the Regatta Format Powerful
                </h4>
                <p className="csrw-banner-text">
                  Every participant becomes part of the experience. Teams are
                  not just watching. They are communicating, coordinating and
                  working together toward a common goal. This creates a much
                  more dynamic and memorable experience than a standard
                  corporate outing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wcre-brutalist-wrapper">
        <div className="wcre-editorial-container">
          {}
          {/* Header block with solid bottom grid line */}
          <div className="wcre-main-header-block">
            <h1 className="wcre-giant-title">
              Why Corporate Sailing REGATTAS Are So Effective for Team Building
            </h1>
          </div>

          {}
          {/* Row 1: Left Image, Right text block */}
          <div className="wcre-grid-row wcre-row-one">
            {/* Row 1 Left: High-performance Yacht Image */}
            <div className="wcre-grid-cell wcre-cell-image">
              <div className="wcre-img-wrapper">
                <img
                  src="assets/img/regatta2.png"
                  alt="Corporate teams executing maneuvers in active regatta"
                  className="wcre-grid-img"
                />
              </div>
            </div>

            {/* Row 1 Right: Deep prose on active collaboration */}
            <div className="wcre-grid-cell wcre-cell-prose">
              <div className="wcre-prose-inner">
                <h3 className="wcre-cell-heading">Highly Effective</h3>
                <p className="wcre-cell-paragraph">
                  A corporate sailing regatta is highly effective for team
                  building because it brings out the exact qualities businesses
                  want to strengthen inside their teams. The sailing environment
                  naturally encourages communication, trust, collaboration,
                  quick thinking and shared responsibility.
                </p>
                <p className="wcre-cell-paragraph">
                  Unlike indoor workshops or passive corporate activities, a
                  regatta creates a live situation where teams must stay
                  connected and aligned. People quickly realise that they cannot
                  succeed alone. They need to listen, support one another and
                  contribute as part of the whole team.
                </p>
              </div>
            </div>
          </div>

          {}
          {/* Row 2: Left text block, Right Image */}
          <div className="wcre-grid-row wcre-row-two">
            {/* Row 2 Left: Narrative on De-Siloing & Trust */}
            <div className="wcre-grid-cell wcre-cell-prose">
              <div className="wcre-prose-inner">
                <h3 className="wcre-cell-heading">Meaningful Adventure</h3>
                <p className="wcre-cell-paragraph">
                  This is why companies often find sailing regattas more
                  meaningful than ordinary team outings. The experience is
                  enjoyable, but it is also practical. It turns teamwork from a
                  concept into a real experience.
                </p>

                <div className="wcre-editorial-quote">
                  <span className="wcre-quote-mark">“</span>
                  <p>
                    The sea has a way of stripping away corporate posturing. It
                    reveals who we are under pressure and creates an unbreakable
                    bond of shared triumph that no office seminar can replicate.
                  </p>
                </div>
              </div>
            </div>

            {/* Row 2 Right: Second Complementary Yachting Image */}
            <div className="wcre-grid-cell wcre-cell-image">
              <div className="wcre-img-wrapper">
                <img
                  src="assets/img/regatta1.png"
                  alt="Yachts competing in perfect coordination on Mumbai waters"
                  className="wcre-grid-img"
                />
              </div>
            </div>
          </div>

          {}
          {/* Editorial trust footer bar structured like the bottom lines of the design layout */}
          <div className="wcre-grid-footer">
            <div className="wcre-footer-pill">
              <Shield size={14} />
              <span>Led by Champion Racing Skippers</span>
            </div>
            <div className="wcre-footer-pill">
              <Award size={14} />
              <span>Premium Experience Guarantee</span>
            </div>
          </div>
        </div>
      </section>

      <section className="rse-root-wrapper">
        <div className="rse-editorial-container">
          {/* Section Header */}
          <div className="rse-header-block">
            <h2 className="rse-section-title">
              What Skills and Outcomes{" "}
              <span className="rse-serif-italic">a Regatta Encourages</span>
            </h2>
            <div className="rse-header-divider"></div>
            <p className="rse-section-paragraph">
              A corporate sailing regatta in Mumbai supports critical business
              objectives, translating directly from tactical on-water maneuvers
              to high-performance desk strategies.
            </p>
          </div>

          {/* Minimalist Editorial List Layout (Replaces the Bento Grid) */}
          <div className="rse-outcomes-list">
            {outcomes.map((item, index) => (
              <div key={index} className="rse-outcome-list-item">
                <div className="rse-item-main-content">
                  {/* Clean, minimalist circular icon container */}
                  <div className="rse-icon-circle">{item.icon}</div>

                  {/* Vertical text stack with clean hierarchy */}
                  <div className="rse-text-stack">
                    <h3 className="rse-item-title">{item.text}</h3>
                    <p className="rse-item-desc">{item.description}</p>
                  </div>
                </div>

                {/* Dynamic decorative element that shifts on row hover */}
                {/* <div className="rse-item-action">
                  <span className="rse-action-badge">Development Goal</span>
                  <ArrowRight size={16} className="rse-arrow-icon" />
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="wefl-pre-root-wrapper">
        <div className="wefl-pre-editorial-container">
          <div className="wefl-pre-split-layout">
            {/* Left Column: Rich Editorial Copy */}
            <div className="wefl-pre-narrative-column">
              <div className="wefl-pre-header-block">
                <h2 className="wefl-pre-section-title">
                  What the Experience{" "}
                  <span className="wefl-pre-serif-italic">Feels Like</span>
                </h2>
                <div className="wefl-pre-header-divider"></div>
              </div>

              <div className="wefl-pre-text-block wefl-pre-highlight-block">
                <div className="wefl-pre-accent-stripe"></div>
                <p className="wefl-pre-paragraph-lead">
                  A corporate sailing regatta feels active, energising and
                  memorable. The atmosphere is very different from a typical
                  conference room, hotel event or indoor activity.
                </p>
                <p className="wefl-pre-paragraph">
                  Once participants step into the experience, they become more
                  present, more engaged and more connected to each other.
                </p>
              </div>

              <div className="wefl-pre-text-block">
                <p className="wefl-pre-paragraph">
                  There is movement, excitement and healthy competition, but
                  there is also a strong sense of team participation. For many
                  companies, that is what makes the experience stand out. It
                  feels rewarding because teams are doing something together,
                  not just attending something together.
                </p>
              </div>

              <div className="wefl-pre-text-block">
                <p className="wefl-pre-paragraph">
                  The sea, the open environment and the live nature of the
                  activity make the entire event feel more premium and more
                  memorable than standard formats.
                </p>
              </div>

              {/* Subtle Features List below text for high-end feel */}
              <div className="wefl-pre-features-list">
                <div className="wefl-pre-feature-item">
                  <Wind size={18} className="wefl-pre-feature-icon" />
                  <span>Energising Setting</span>
                </div>
                <div className="wefl-pre-feature-item">
                  <Compass size={18} className="wefl-pre-feature-icon" />
                  <span>Active Presence</span>
                </div>
                <div className="wefl-pre-feature-item">
                  <Waves size={18} className="wefl-pre-feature-icon" />
                  <span>Premium Marine Edge</span>
                </div>
              </div>
            </div>

            {}
            <div className="wefl-pre-image-column">
              <div className="wefl-pre-image-wrapper">
                {/* Outer decorative border frame for editorial look */}
                {/* <div className="wefl-pre-image-accent-border"></div> */}

                {/* High-quality corporate/team sailing image */}
                <img
                  className="wefl-pre-main-image"
                  src="assets/img/regatta4.png"
                  alt="Corporate team sailing on a premium yacht"
                />

                {/* Elegant Floating Stat Badge overlay on image */}
                <div className="wefl-pre-floating-badge">
                  <span className="wefl-pre-badge-title">Mumbai Harbour</span>
                  <span className="wefl-pre-badge-subtitle">
                    The Premium Alternative
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="csrb-root-wrapper">
      <div className="csrb-editorial-container">
        
        {}
        <div className="csrb-split-layout">
          
          {/* Left Column: Narrative Copy */}
          <div className="csrb-narrative-column">
            <h2 className="csrb-section-title">
              Who Corporate Sailing Regattas <span className="csrb-serif-italic">Are Best For</span>
            </h2>
            <div className="csrb-title-divider"></div>
            <p className="csrb-lead-paragraph">
              Corporate sailing regattas work especially well for businesses that want more than just a social outing. They are ideal for companies looking for stronger engagement and real participation.
            </p>
          </div>

          {/* Right Column: Premium Interactive List */}
          <div className="csrb-list-column">
            <span className="csrb-list-eyebrow">GOOD FOR</span>
            <ul className="csrb-list">
              {benefitsList.map((item, index) => (
                <li key={index} className="csrb-list-item">
                  <div className="csrb-bullet-wrapper">
                    {/* Minimalist modern checkmark icon inside a subtle geometric container */}
                    <svg 
                      className="csrb-bullet-icon" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="csrb-item-text">{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
      </section>

      {/* <section className="ibw-cntr-wrapper">
      <div className="ibw-cntr-container">
        
       
        <div className="ibw-cntr-header">
        
          <h2 className="ibw-cntr-title">
            Why Companies Choose Indiaboats for Corporate Sailing Regattas
          </h2>
          <div className="ibw-cntr-divider"></div>
          
          <div className="ibw-cntr-narrative">
            <p className="ibw-cntr-paragraph">
              Indiaboats offers premium sailing and yacht experiences in Mumbai and helps companies
              create corporate regattas that feel smooth, structured and meaningful. We understand
              that a successful corporate event should not only look impressive, but also create
              genuine engagement and leave teams with a strong shared memory.
            </p>
            <p className="ibw-cntr-paragraph">
              That is why our focus is not only on the sailing format itself, but also on the overall
              event experience. From helping you choose the right structure for your team to making
              the event feel premium and well managed, Indiaboats helps businesses create
              team-building experiences that truly stand out.
            </p>
          </div>
        </div>

        {}
        <div className="ibw-cntr-grid">
          {highlights.map((item, index) => (
            <div key={index} className="ibw-cntr-card">
              <div className="ibw-cntr-card-accent"></div>
              <div className="ibw-cntr-icon-box">
                {item.icon}
              </div>
              <p className="ibw-cntr-card-text">
                {item.text}
              </p>
            </div>
          ))}
        </div>

      </div>
      </section>  */}

       <section className="crvs-section">
      <div className="crvs-container">
        
        {}
        <h2 className="crvs-main-heading">
          Corporate Sailing Regatta vs Standard Team Outing
        </h2>

        {}
        <div className="crvs-comparison-grid">
          
          {/* Card 1: Standard Team Outing */}
          <div className="crvs-card crvs-card-muted">
            <div className="crvs-card-header">
              <div className="crvs-icon-wrapper crvs-icon-muted">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="crvs-svg-icon">
                  <path d="M17 18a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2" />
                  <rect x="3" y="4" width="18" height="12" rx="2" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <h3 className="crvs-card-title crvs-title-muted">Standard Team Outing</h3>
            </div>
            
            <div className="crvs-card-content">
              <p className="crvs-paragraph">
                A standard team outing is often social and enjoyable, but it may not always create real engagement.
              </p>
              <p className="crvs-paragraph">
                Instead of active collaboration, it often means simply attending a venue, offering a change of setting without a dynamic driving force or shared objective.
              </p>
              
              <div className="crvs-divider"></div>
              
              <ul className="crvs-feature-list">
                <li className="crvs-feature-item">
                  <span className="crvs-bullet crvs-bullet-muted"></span>
                  Passive entertainment formats
                </li>
                <li className="crvs-feature-item">
                  <span className="crvs-bullet crvs-bullet-muted"></span>
                  Limited meaningful connection
                </li>
                <li className="crvs-feature-item">
                  <span className="crvs-bullet crvs-bullet-muted"></span>
                  Familiar, standard environments
                </li>
              </ul>
            </div>
          </div>

          {/* Card 2: Corporate Sailing Regatta */}
          <div className="crvs-card crvs-card-active">
            <div className="crvs-card-accent-glow"></div>
            <div className="crvs-card-header">
              <div className="crvs-icon-wrapper crvs-icon-active">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="crvs-svg-icon">
                  <path d="M22 3c-1.1 0-2 1.2-2 2.5V17c0 .8-.4 1.5-1 2H5c-.6-.5-1-1.2-1-2V5.5C4 4.2 3.1 3 2 3" />
                  <path d="M4 17a4 4 0 0 1 8 0v2" />
                  <path d="M12 17a4 4 0 0 1 8 0v2" />
                </svg>
              </div>
              <h3 className="crvs-card-title crvs-title-active">Corporate Sailing Regatta</h3>
            </div>
            
            <div className="crvs-card-content">
              <p className="crvs-paragraph">
                A corporate sailing regatta is different because it gives teams a live challenge and a shared objective.
              </p>
              <p className="crvs-paragraph">
                Instead of simply attending a venue, teams participate in something dynamic. They communicate more, contribute more, and remember the experience more clearly afterward.
              </p>
              
              <div className="crvs-divider"></div>
              
              <ul className="crvs-feature-list">
                <li className="crvs-feature-item">
                  <span className="crvs-bullet crvs-bullet-active"></span>
                  Active communication and collaboration
                </li>
                <li className="crvs-feature-item">
                  <span className="crvs-bullet crvs-bullet-active"></span>
                  High-impact team values & leadership
                </li>
                <li className="crvs-feature-item">
                  <span className="crvs-bullet crvs-bullet-active"></span>
                  Premium, memorable on-water setting
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
      </section>

       {/* <section className="wcer-section">
      <div className="wcer-container">
        
        
        <h2 className="wcer-heading">
          Which Corporate Experience Is Right for Your Business
        </h2>

      
        <div className="wcer-grid">
          
         
          <div className="wcer-card wcer-card-active">
          
            
          
            <div className="wcer-card-header">
              <div className="wcer-icon-box">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wcer-svg">
                  <path d="M22 3c-1.1 0-2 1.2-2 2.5V17c0 .8-.4 1.5-1 2H5c-.6-.5-1-1.2-1-2V5.5C4 4.2 3.1 3 2 3" />
                  <path d="M4 17a4 4 0 0 1 8 0v2" />
                  <path d="M12 17a4 4 0 0 1 8 0v2" />
                </svg>
              </div>
              <h3 className="wcer-card-title">Team Development</h3>
            </div>

            
            <div className="wcer-image-wrapper">
              <div 
                className="wcer-card-image" 
                style={{ backgroundImage: 'url("assets/img/regatta1.png")' }}
                aria-label="Corporate sailing regatta team working together on deck"
              ></div>
            </div>
            
           
            <p className="wcer-paragraph">
              If your main objective is team building, collaboration, leadership development and active participation, <span className="wcer-highlight">a corporate sailing regatta is usually the best fit.</span>
            </p>
            
            <div className="wcer-footer-indicator">
              <span>Best Fit: Regatta</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wcer-arrow">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </div>

        
          <div className="wcer-card">
            
            
            <div className="wcer-card-header">
              <div className="wcer-icon-box wcer-icon-alt">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wcer-svg">
                  <circle cx="12" cy="12" r="10" />
                  <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
                </svg>
              </div>
              <h3 className="wcer-card-title">Business Hospitality</h3>
            </div>

           
            <div className="wcer-image-wrapper">
              <div 
                className="wcer-card-image" 
                style={{ backgroundImage: 'url("assets/img/regatta2.png")' }}
                aria-label="Premium luxury yacht deck for corporate networking"
              ></div>
            </div>
            
           
            <p className="wcer-paragraph">
              If your main objective is client hosting, executive networking or premium business hospitality, <span className="wcer-highlight-alt">a corporate yacht event may be more suitable.</span>
            </p>
            
            <div className="wcer-footer-indicator">
              <span>Best Fit: Yacht Event</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wcer-arrow">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </div>

         
          <div className="wcer-card">
          
            <div className="wcer-card-header">
              <div className="wcer-icon-box wcer-icon-alt">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wcer-svg">
                  <circle cx="12" cy="8" r="7" />
                  <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
                </svg>
              </div>
              <h3 className="wcer-card-title">Recognition & Social</h3>
            </div>

          
            <div className="wcer-image-wrapper">
              <div 
                className="wcer-card-image" 
                style={{ backgroundImage: 'url("assets/img/ce_bg.png")' }}
                aria-label="Upscale dinner venue, corporate awards and recognition ceremonies"
              ></div>
            </div>
            
            
            <p className="wcer-paragraph">
              If your main objective is celebration, recognition and internal company gatherings, <span className="wcer-highlight-alt">a corporate party or awards ceremony may be the better option.</span>
            </p>
            
            <div className="wcer-footer-indicator">
              <span>Best Fit: Party & Awards</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="wcer-arrow">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </div>
          </div>

        </div>
      </div>
      </section>       */}


       <section className="wtei-section">
      <div className="wtei-container">
        <div className="wtei-grid">
          
          {/* Left Column: Title and Narrative Copy */}
          <div className="wtei-col-left">
            <h2 className="wtei-title">
              What to Expect with Indiaboats
            </h2>
            <p className="wtei-paragraph">
              When you plan a corporate sailing regatta with Indiaboats, the experience is designed to feel premium, engaging and easy to organise.
            </p>
            <p className="wtei-paragraph">
              We help businesses understand what regatta format suits their team size, company culture and event objective so the final experience feels both effective and memorable.
            </p>
          </div>

          { }
          {/* Right Column: Inclusions Style List */}
          <div className="wtei-col-right">
            <ul className="wtei-list">
              
              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Premium sailing regatta experience in Mumbai</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Guidance based on team size and business objective</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Strong team-building and leadership format</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Scenic and memorable on-water environment</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Better engagement than routine corporate venues</span>
              </li>

              <li className="wtei-list-item">
                <span className="wtei-list-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span className="wtei-list-text">Supportive and experience-led planning</span>
              </li>

            </ul>
          </div>

        </div>
      </div>
      </section>

        <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Coordination and  <span>Guest Experience</span>
          </h2>

          <p className="scUniqueParagraph">
           At Indiaboats, safety is central to every corporate sailing regatta. We place strong emphasis on trained crew, responsible operations, guest support and professional coordination so your corporate experience feels enjoyable, smooth and confidently managed.
          </p>
        </div>
      </div>
    </section> 

     <FAQSection
  pageKey="corporate-sailing-regatta-mumbai"
  title="Frequently Asked Questions About Corporate Events in Mumbai"
  faqData={regattaFaqs}
/>
     
             <section className="btfUniqueSection" id='corporate_e_form'>
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us About Your
              <span> Business Event</span>
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

          <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Company Name</label>
      <input type="text" placeholder="Enter company name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Event Objective</label>
      <select>
        <option>Select event objective</option>
        <option>Client Appreciation</option>
        <option>Networking Evening</option>
        <option>Leadership Gathering</option>
        <option>Partner/Investor Meet</option>
        <option>Reward & Recognition</option>
        <option>Other</option>
      </select>
    </div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your corporate event requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Request a Proposal</span>
  </button>
</form>
        </div>
      </div>
    </section>

        
      <Footer />
    </div>
  );
};

export default Regattas;
